import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ConnectedTvIcon(props: IconProps) {
    return <Icon {...props} iconKey={"connected_tv"}/>
}
